import React from "react"
import styles from "./icon.module.scss"
import classnames from "@utils/classnames"

export const AngleRight = ({ className }) => (
  <svg viewBox="0 0 8 12" className={classnames(styles.icon, className)}>
    <path
      fill="currentColor"
      d="M5.22168604,6 L0.859497044,10.0506041 C0.404197905,10.4733818 0.377834128,11.1852038 0.8006119,11.640503 C1.22338967,12.0958021 1.93521165,12.1221659 2.39051079,11.6993881 L7.64050657,6.82439202 C8.11982954,6.3793064 8.11982954,5.6206936 7.64050657,5.17560798 L2.39051079,0.3006119 C1.93521165,-0.122165872 1.22338967,-0.0958020947 0.8006119,0.359497044 C0.377834128,0.814796182 0.404197905,1.52661816 0.859497044,1.94939593 L5.22168604,6 Z"
    />
  </svg>
)

export const Unfold = ({ className }) => (
  <svg
    viewBox="0 0 46 46"
    version="1.1"
    className={classnames(styles.icon, className)}
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-252.000000, -6817.000000)" fill="currentColor">
        <path d="M275,6817 C287.702549,6817 298,6827.29745 298,6840 C298,6852.70255 287.702549,6863 275,6863 C262.297451,6863 252,6852.70255 252,6840 C252,6827.29745 262.297451,6817 275,6817 Z M275,6831 L274.852372,6831.00597 C273.927313,6831.08106 273.2,6831.85559 273.2,6832.8 L273.2,6832.8 L273.2,6838.2 L267.8,6838.2 L267.652372,6838.20597 C266.727313,6838.28106 266,6839.05559 266,6840 L266,6840 L266.005967,6840.14763 C266.081059,6841.07269 266.855593,6841.8 267.8,6841.8 L267.8,6841.8 L273.2,6841.799 L273.2,6847.2 L273.205967,6847.34763 C273.281059,6848.27269 274.055593,6849 275,6849 L275,6849 L275.147628,6848.99403 C276.072687,6848.91894 276.8,6848.14441 276.8,6847.2 L276.8,6847.2 L276.799,6841.799 L282.2,6841.8 L282.347628,6841.79403 C283.272687,6841.71894 284,6840.94441 284,6840 L284,6840 L283.994033,6839.85237 C283.918941,6838.92731 283.144407,6838.2 282.2,6838.2 L282.2,6838.2 L276.799,6838.2 L276.8,6832.8 L276.794033,6832.65237 C276.718941,6831.72731 275.944407,6831 275,6831 L275,6831 Z" />
      </g>
    </g>
  </svg>
)

export const Share = ({ className }) => (
  <svg
    viewBox="0 0 30 30"
    version="1.1"
    className={classnames(styles.icon, className)}
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-37.000000, -12025.000000)">
        <g transform="translate(37.000000, 12025.000000)">
          <circle fill="currentColor" cx="15" cy="15" r="15" />
          <path
            d="M15.8090479,10.3957349 L15.8090479,7 L21,12.2499359 L15.8090479,17.4998718 L15.8090479,14.0300099 C9.76971861,13.8863728 10.0291774,18.1824045 11.5661477,21 C7.77165729,16.8509399 8.57767898,10.2056722 15.8090479,10.3957349"
            id="Fill-1"
            stroke="#FFFFFF"
            fill="#FFFFFF"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
    </g>
  </svg>
)

export const AngleLeft = ({ className }) => (
  <svg viewBox="0 0 44 48" className={classnames(styles.icon, className)}>
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-228.000000, -6942.000000)" fill="currentColor">
        <g transform="translate(228.000000, 6942.000000)">
          <g transform="translate(0.000000, 0.220900)">
            <path d="M42.1565,47.50005 L43.976,0.27905 C43.976,0.27905 15.6895,23.97455 0,47.50005 L42.1565,47.50005 Z" />
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export const AngleBottom = ({ className }) => (
  <svg
    viewBox="0 0 61 22"
    version="1.1"
    className={classnames(styles.icon, className)}
  >
    <title>Fill 1</title>
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-346.000000, -7484.000000)" fill="currentColor">
        <polygon points="346 7484 376.499756 7506 407 7484" />
      </g>
    </g>
  </svg>
)

export const Refresh = ({ className }) => (
  <svg viewBox="0 0 28 38" className={classnames(styles.icon, className)}>
    <path
      d="m609.907752 4534.33545-2.463452 2.45546c.74241 1.41273 1.181107 3.01045 1.181107 4.70909 0 5.56514-4.538827 10.09091-10.123778 10.09091v-5.04546l-6.749186 6.72728 6.749186 6.72727v-5.04545c7.45785 0 13.498371-6.02091 13.498371-13.45455 0-2.64045-.776156-5.09591-2.092248-7.16455m-12.409381-3.92636v5.04546l6.749186-6.72728-6.749186-6.72727v5.04545c-7.45785 0-13.498371 6.02091-13.498371 13.45455 0 2.64045.776156 5.09591 2.092248 7.16455l2.463452-2.45546c-.759283-1.39759-1.181107-3.01045-1.181107-4.70909 0-5.56682 4.538827-10.09091 10.123778-10.09091"
      fill="currentColor"
      fillRule="evenodd"
      transform="translate(-584 -4522)"
    />
  </svg>
)
